// Normalizes a search query for case-insensitive, trimmed comparisons.
export const normalizeSearchQuery = (query: string): string =>
  query.trim().toLowerCase();
